(function () {
  'use strict';

  var ROOT_SEL = '.msc-news';
  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── MODULE 1: SCROLL REVEAL ─────────────────────────────────

  function initReveal() {
    if (reducedMotion) {
      var all = root.querySelectorAll('.msc-news-card, .msc-news-hero');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.add('msc-news--visible');
      }
      return;
    }

    if (!('IntersectionObserver' in window)) {
      var fallback = root.querySelectorAll('.msc-news-card, .msc-news-hero');
      for (var j = 0; j < fallback.length; j++) {
        fallback[j].classList.add('msc-news--visible');
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) {
          entries[k].target.classList.add('msc-news--visible');
          observer.unobserve(entries[k].target);
        }
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    var targets = root.querySelectorAll('.msc-news-card, .msc-news-hero');
    for (var m = 0; m < targets.length; m++) {
      observer.observe(targets[m]);
    }

    return observer;
  }

  var revealObserver = initReveal();

  // ── MODULE 2: CATEGORY FILTERS ──────────────────────────────

  function initFilters() {
    var filterBar = root.querySelector('.msc-news__filters');
    if (!filterBar) return;

    var pills = filterBar.querySelectorAll('.msc-news__filter-pill');
    var grid = root.querySelector('#msc-news-grid');
    var hero = root.querySelector('.msc-news-hero');

    filterBar.addEventListener('click', function (e) {
      var pill = e.target.closest('.msc-news__filter-pill');
      if (!pill) return;

      var filterTag = pill.getAttribute('data-filter');

      // update active pill
      for (var i = 0; i < pills.length; i++) {
        pills[i].classList.remove('msc-news__filter-pill--active');
        pills[i].setAttribute('aria-selected', 'false');
      }
      pill.classList.add('msc-news__filter-pill--active');
      pill.setAttribute('aria-selected', 'true');

      // filter cards
      applyFilter(filterTag, grid);

      // show/hide hero based on filter
      if (hero) {
        hero.style.display = filterTag === 'all' ? '' : 'none';
      }
    });
  }

  function applyFilter(filterTag, grid) {
    if (!grid) return;
    var cards = grid.querySelectorAll('.msc-news-card');

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (filterTag === 'all') {
        card.setAttribute('data-hidden', 'false');
        card.style.display = '';
      } else {
        var tags = (card.getAttribute('data-tags') || '').toLowerCase().split(',');
        var match = false;
        for (var j = 0; j < tags.length; j++) {
          if (tags[j].trim() === filterTag.toLowerCase()) {
            match = true;
            break;
          }
        }
        card.setAttribute('data-hidden', match ? 'false' : 'true');
        card.style.display = match ? '' : 'none';
      }
    }
  }

  initFilters();

  // ── MODULE 3: LOAD MORE ─────────────────────────────────────

  function initLoadMore() {
    var btn = document.getElementById('msc-news-load-more');
    if (!btn) return;

    var currentPage = parseInt(btn.getAttribute('data-current-page'), 10);
    var totalPages = parseInt(btn.getAttribute('data-total-pages'), 10);
    var sectionId = btn.getAttribute('data-section-id');
    var grid = root.querySelector('#msc-news-grid');
    var loading = false;

    btn.addEventListener('click', function () {
      if (loading || currentPage >= totalPages) return;
      loading = true;
      btn.textContent = 'Loading...';
      btn.disabled = true;

      var nextPage = currentPage + 1;
      var url = window.location.pathname + '?page=' + nextPage + '&section_id=' + sectionId;

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.msc-news-card');

          for (var i = 0; i < newCards.length; i++) {
            grid.appendChild(newCards[i]);

            // observe new cards for reveal
            if (revealObserver && !reducedMotion) {
              revealObserver.observe(newCards[i]);
            } else {
              newCards[i].classList.add('msc-news--visible');
            }
          }

          // re-apply active filter to new cards
          var activePill = root.querySelector('.msc-news__filter-pill--active');
          if (activePill) {
            var activeFilter = activePill.getAttribute('data-filter');
            if (activeFilter !== 'all') {
              applyFilter(activeFilter, grid);
            }
          }

          currentPage = nextPage;
          loading = false;

          if (currentPage >= totalPages) {
            btn.style.display = 'none';
          } else {
            btn.textContent = 'Load More';
            btn.disabled = false;
          }
        })
        .catch(function () {
          loading = false;
          btn.textContent = 'Load More';
          btn.disabled = false;
        });
    });
  }

  initLoadMore();

})();
